import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const courseDiscussionCommentReplyEditApi = createAsyncThunk(
    'auth/courseDiscussionCommentReplys/Edit',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.put(apiRoutes.publicapiAction("discussion/replies/update", 1), data)
            return response?.data
        } catch (error) {
            let errorData = error?.response?.data || {};
            if (!errorData.message) {
                errorData.message = "Something went wrong.";
            }
            return rejectWithValue(errorData)
        }
    }
)

const courseDiscussionCommentReplyEditSlice = createSlice({
    name: 'courseDiscussionCommentReply Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(courseDiscussionCommentReplyEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(courseDiscussionCommentReplyEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(courseDiscussionCommentReplyEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const courseDiscussionCommentReplyEditReducer = courseDiscussionCommentReplyEditSlice.reducer
